import { Pipe, PipeTransform } from '@angular/core';
import { DateFormats, NebulaDateService } from './nebula-date.service';

@Pipe({
  name: 'nebulaDate'
})
export class NebulaDatePipe implements PipeTransform {

  constructor(private nebulaDate: NebulaDateService) { }

  transform(date: Date, format?: string | DateFormats): any {
    return this.nebulaDate.format(date, format);
  }

}
